// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7a620304","952":"fe5281e9"}[chunkId] + ".chunk.js";
};